import { useState, useEffect } from 'react';
import { emergencyMode } from '@/utils/emergencyMode';
import { AlertTriangle, X } from 'lucide-react';

export const EmergencyModeIndicator = () => {
  const [isActive, setIsActive] = useState(false);
  const [status, setStatus] = useState<any>(null);

  useEffect(() => {
    const checkStatus = () => {
      const currentStatus = emergencyMode.getStatus();
      setIsActive(currentStatus.isActive);
      setStatus(currentStatus);
    };

    // Check initially
    checkStatus();

    // Check every 5 seconds
    const interval = setInterval(checkStatus, 5000);

    return () => clearInterval(interval);
  }, []);

  if (!isActive) return null;

  return (
    <div className="fixed top-4 right-4 z-50 bg-amber-100 border border-amber-300 rounded-lg p-3 shadow-lg max-w-sm">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-amber-800">
            Emergency Mode Active
          </div>
          <div className="text-xs text-amber-700 mt-1">
            {status?.reason || 'System stability protection'}
          </div>
          <div className="text-xs text-amber-600 mt-1">
            Some features temporarily disabled for stability
          </div>
        </div>
        <button
          onClick={() => emergencyMode.deactivate()}
          className="text-amber-400 hover:text-amber-600 p-1"
          title="Deactivate Emergency Mode"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};